const authTypes = {
  LOG_IN_START: "LOG_IN_START",
  LOG_IN_SUCCESS: "LOG_IN_SUCCESS",
  LOG_IN_FAILURE: "LOG_IN_FAILURE",
  LOG_OUT: "LOG_OUT",
  UPDATE_TOKEN: "UPDATE_TOKEN",
};

export default authTypes;
